import { gql } from '@apollo/client';

export const QUERY_ONBOARDING = gql`
  query onBoardingPage {
    onBoardingPage {
      data {
        attributes {
          dailyBubbleTitle
          delvingDeeperTitle
          aboutYouTitle
          reachingYouTitle
        }
      }
    }
  }
`;
